// autogenerated (see postcss.config.js) - do not edit
import { CSSProperties } from "react";

export interface VnSDKCSSProperties extends CSSProperties {
  "--vn-sdk-primary-color"?: string;
  "--vn-sdk-contrast-color"?: string;
  "--vn-sdk-background-color"?: string;
  "--vn-sdk-input-background-color"?: string;
  "--vn-sdk-secondary-color"?: string;
  "--vn-sdk-secondary-contrast-color"?: string;
  "--vn-sdk-separator-color"?: string;
  "--vn-sdk-muted-color"?: string;
  "--vn-sdk-error-background"?: string;
  "--vn-sdk-error-border"?: string;
  "--vn-sdk-error-text"?: string;
  "--vn-sdk-shadow-sm"?: string;
  "--vn-sdk-shadow-md"?: string;
  "--vn-sdk-shadow-lg"?: string;
  "--vn-sdk-dev-console-bg"?: string;
  "--vn-sdk-dev-console-text"?: string;
}
